import { SignatureType } from '@streamr/trackerless-network';
import { IDENTITY_MAPPING } from './identity/IdentityMapping';
const stringVersionsOfSignatureTypes = {
    // Read key pair SignatureTypes from IdentityMapping
    ...Object.fromEntries(IDENTITY_MAPPING.map((idMapping) => [idMapping.signatureType, idMapping.keyType])),
    // These special ones need to be added manually
    [SignatureType.ECDSA_SECP256K1_LEGACY]: 'ECDSA_SECP256K1_LEGACY',
    [SignatureType.ERC_1271]: 'ERC_1271',
};
function signatureTypeToString(signatureType) {
    const result = stringVersionsOfSignatureTypes[signatureType];
    if (!result) {
        throw new Error(`Unknown signature type: ${signatureType}`);
    }
    return result;
}
export const convertStreamMessageToMessage = (msg) => {
    return {
        content: msg.getParsedContent(),
        streamId: msg.getStreamId(),
        streamPartition: msg.getStreamPartition(),
        timestamp: msg.getTimestamp(),
        sequenceNumber: msg.getSequenceNumber(),
        signature: msg.signature,
        signatureType: signatureTypeToString(msg.signatureType),
        publisherId: msg.getPublisherId(),
        msgChainId: msg.getMsgChainId(),
        encryptionKeyId: msg.groupKeyId,
        streamMessage: msg
        // TODO add other relevant fields (could update some test assertions to
        // use those keys instead of getting the fields via from streamMessage property)
    };
};
//# sourceMappingURL=Message.js.map